

export enum ObservationConcernLevelEnum {
    Low = 'LOW',
    Medium = 'MEDIUM',
    High = 'HIGH'
}